// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__druk_861e8d', '__druk_Fallback_861e8d'","fontWeight":700},"className":"__className_861e8d","variable":"__variable_861e8d"};